// extracted by mini-css-extract-plugin
export default {"wrapper":"CustomPromptsSection_wrapper__Nq-kj","header":"CustomPromptsSection_header__zrfxE"};